import { TooltipQuestionIcon } from './TooltipQuestionIcon';

/**
 * author: Jeff Anders
 * id 99CABA6D-9506-4EC7-8721-8CE38B157E75
 * name tooltip-question
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tooltip-question.svg
 * tags
 * - Tooltip 
 */
export const TooltipHelpIcon = TooltipQuestionIcon;
export default TooltipHelpIcon